import React from 'react'
import cn from 'classnames'

function List({ children, className }) {
  return (
    <ul className={cn('list-group list-group-flush rounded', className)} style={{ backgroundColor: '#1a1d21', border: '1px solid rgba(255, 255, 255, 0.04)' }}>
      {children}
    </ul>
  )
}

export default List
